import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('members')
export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const SET_ACTIVE_STATE = createType('SET_ACTIVE_STATE')
export const UPDATED = createType('UPDATED')
